import { ReactComponent as InfoIcon } from '../../images/Info.svg'

export const InfoIconSVG = InfoIcon